module.exports = __webpack_public_path__ + "media/icons/icon-medal-third-9f920452.svg";